import { type RouteObject } from 'react-router'

/**
 * Creates routes for dashboard feature.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: '',
      lazy: {
        Component: () =>
          import('@/features/dashboard/DashboardView/DashboardViewContainer').then(
            (r) => r.default,
          ),
      },
      children: [
        // The dashboard shows service selection dialogs on this route.
        {
          path: '/new',
          Component: null,
        },
      ],
    },
  ]
}
